import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the ApplyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-apply',
  templateUrl: 'apply.html',
})
export class ApplyPage {
    
    list: string = 'completed';

	loginId: string;
	email: string;
    api_key: string;
    version: string;
	wallet_address: string;
    coin: string = '';
    office_address: string;
	address: string;

	product: any = [];

	completed_list: any = [];
	pending_list: any = [];
    
	coin_unit: string;	
	unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;
    
    balance_point: any = [];
    balance_coin: string;

	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
        private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {

	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "apply");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).apply;
	}

	_init() {		
		this.completed_list = [];
		this.pending_list = [];
		
        let url = "deposit/tron";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				this.office_address = res.address;
                this.product = res.product;
                this.balance_coin = res.balance.coin;
                this.balance_point = res.balance.point;
 
                if (res.list != undefined) {   
                    if(res.list.completed != undefined) {
                        this.completed_list = res.list.completed;
                    }
                    if(res.list.pending != undefined) {
                        this.pending_list = res.list.pending;
                    }
                }

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: err.message,
				buttons: ['OK']
			});
			alert.present();
		});
	}

	_copy_office(office_address) {
		this.clipboard.copy(office_address);
		let alert = this.alertCtrl.create({
            title: "Copy",
            message: office_address, 
            buttons: ['OK']
		});
		alert.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/apply/apply.ts